import React, { useState } from "react";
import "./SideBar.css";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import sideBarOptions from "./sideBarOptions";

const SideBar = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  // Get user rights safely
  const rights =
    JSON.parse(localStorage.getItem("user"))?.data?.urights || [];

  // Extract right_ids
  const rightKeyArr = rights.map((r) => r.right_id);

  // 🔑 Permission Checker
  const hasAccess = (rightId) => {
    if (rightId === 0) return true; // Public
    return rightKeyArr.includes(rightId);
  };

  // 🔑 Check if item has access (supports both right_id and rigths_arr)
  const hasItemAccess = (item) => {
    // If item has rigths_arr, check if any right matches
    if (item.rigths_arr && Array.isArray(item.rigths_arr)) {
      return (
        item.rigths_arr.includes(0) ||
        rightKeyArr.some((r) => item.rigths_arr.includes(r))
      );
    }
    // Otherwise, check right_id
    return hasAccess(item.right_id);
  };

  // 👉 Main menu items (exclude items with submenus, they're handled separately)
  const filteredSidebar = sideBarOptions.filter(
    (item) => !item.hasSubMenu && hasItemAccess(item)
  );

  // 👉 Menus which have submenus
  const menusWithSubmenu = sideBarOptions.filter(
    (item) => item.hasSubMenu === true
  );

  // 👉 Only include submenu parents if any child is allowed
  const subMenuArr = [];

  for (let i = 0; i < menusWithSubmenu.length; i++) {
    const parent = menusWithSubmenu[i];

    const isAllowed =
      parent.rigths_arr?.includes(0) ||
      rightKeyArr.some((r) => parent.rigths_arr?.includes(r));

    if (isAllowed) {
      subMenuArr.push(parent);
    }
  }

  // 👉 Merge final options
  const finalOptions = [...subMenuArr, ...filteredSidebar];

  // Submenu open state
  const [open, setOpen] = useState(false);

  return (
    <ul className="navs-links">
      {finalOptions.map((items) => {
        const isActive = items.hasSubMenu
          ? splitLocation[1] ===
          items.locations.find((el) => el === splitLocation[1])
          : splitLocation[1] === `${items.locations}`;

        return (
          <li key={items.url} className={isActive ? "is-active" : ""}>
            {!items.hasSubMenu ? (
              <Link to={items.url}>
                <i className={items.iconClass}></i>
                <span className="links_name">{items.name}</span>
              </Link>
            ) : (
              <>
                <Link
                  to={items.url}
                  onMouseOver={() => setOpen(true)}
                  onMouseOut={() => setOpen(false)}
                  className={open ? "question" : ""}
                >
                  <i className={items.iconClass}></i>
                  <span className="links_name">{items.name}</span>
                </Link>

                <Collapse in={open}>
                  <div
                    className="sidebar-collapsible"
                    onMouseOver={() => setOpen(true)}
                    onMouseOut={() => setOpen(false)}
                  >
                    {items.subMenu
                      .filter((sub) => hasAccess(sub.right_id))
                      .map((subItems) => (
                        <Link
                          key={subItems.url}
                          to={subItems.url}
                          className={
                            splitLocation[1] ===
                              `${subItems.locations}`
                              ? "is-active-sub"
                              : ""
                          }
                        >
                          <i className="fa-solid fa-arrow-right"></i>
                          <span className="links_name">
                            {subItems.name}
                          </span>
                        </Link>
                      ))}
                  </div>
                </Collapse>
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default SideBar;
